<template>
  <div id="help-canvas" class="offcanvas-background">
    <div class="offcanvas offcanvas-right"
       v-click-outside="close">
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center">
        <span class="font-weight-light" style="font-size: 2.5rem">
             {{$t('help.modal.title')}}
          </span>
      </div>
      <span class="btn btn-xs btn-icon btn-hover-primary ml-auto"
            @click="close">
        <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                    width="20" height="20"/>
      </span>
    </div>
    <div class="offcanvas-content px-4 px-md-7">
      <div class="profile-info">
        <form @submit.prevent="sendMessage">
          <div class="form-group"
               :class="{'validated' : true}"
          >
            <label>{{$t('help.modal.message.title')}}</label>
            <textarea type="text"
                      v-model="message" class="form-control form-control-sm"
                      style="height: 60vh"
                      required>
            </textarea>
          </div>
          <div class="d-flex flex-column mt-5">
            <button class="btn btn-primary btn-sm px-8 text-uppercase mb-2">
              {{$t('help.modal.message.send')}}
            </button>
            <button class="btn btn-outline-primary btn-sm px-8 text-uppercase" @click="close">
              {{$t('app.button.cancel')}}
            </button>
          </div>
        </form>
      </div>
    </div>
    <!--end::Content-->
  </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { SEND_HELP_MESSAGE } from '@/store/actions.type';
import store from '@/store';

export default {
  name: 'HelpCanvas',
  computed: {
    ...mapGetters(['currentUser', 'organization']),
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    close() {
      if (document.getElementById('help-canvas').classList.contains('offcanvas-on')) {
        this.$emit('close', { src: 'help' });
      }
    },
    sendMessage() {
      const { message } = this;
      const session = store.getters.currentSession.id;
      const organization = store.getters.organization.id;
      this.$store.dispatch(SEND_HELP_MESSAGE, { message, session, organization }).then(() => {
        this.$toasted.success(this.$t('help.modal.message.send.success'));
        this.message = '';
        this.$Progress.finish();
        this.close();
      }).catch(() => {
        this.$toasted.error(this.$t('help.modal.message.send.error'));
      });

      return true;
    },
  },
};
</script>
